// src/components/Labs/biology/components/SpecimenBottle.jsx
import React from "react";
import { useDrag } from "react-dnd";
import { ItemTypes } from "../../../../utils/constants";

export default function SpecimenBottle({ specimen, disabled }) {
  const [{ isDragging }, drag] = useDrag(
    () => ({
      type: ItemTypes.SPECIMEN,
      item: {
        id: specimen.id,
        name: specimen.name,
        color: specimen.color,
      },
      canDrag: () => !disabled,
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
    }),
    [disabled, specimen.id]
  );

  return (
    <div
      ref={drag}
      className={[
        "flex flex-col items-center justify-center p-3 rounded-xl shadow-md text-white transition-all duration-200 w-28",
        isDragging ? "opacity-40 scale-90" : "hover:scale-105",
        disabled ? "opacity-40 cursor-not-allowed" : "cursor-grab",
      ].join(" ")}
      style={{ backgroundColor: specimen.color || "#ec4899" }}
      title={disabled ? "Experiment complete" : specimen.name}
    >
      <div className="text-2xl mb-1">{specimen.emoji || "🧫"}</div>
      <span className="text-xs font-medium text-center leading-tight">
        {specimen.name}
      </span>
    </div>
  );
}
